import { getResourceCode } from '../';
import { MEDICATION_DERIVATION_REASON_SELECT_ID, MEDICATION_REQUEST_INTENT_SELECT_ID, MEDICATION_REQUEST_STATUS_SELECT_ID, MEDICATION_STATEMENT_STATUS_SELECT_ID, MEDICATION_TIMING_ABBREVIATION_SELECT_ID, } from '../../definitions';
import { $definitions } from '../../definitions';
export class MedicationsExtractor {
    constructor(resource, additional = {}) {
        this._data = resource;
        this.additional = additional;
    }
    get data() {
        return this._data;
    }
    get code() {
        var _a;
        return getResourceCode((_a = this.data.medication) === null || _a === void 0 ? void 0 : _a.code);
    }
    get status() {
        return $definitions.selects.getValue(this.getStatusSelectId(), this.data.status || this.additional.status);
    }
    get frequency() {
        var _a, _b, _c, _d, _e, _f;
        const code = (_c = (_b = (_a = this.data.dosage) === null || _a === void 0 ? void 0 : _a.timing) === null || _b === void 0 ? void 0 : _b.code) === null || _c === void 0 ? void 0 : _c.code;
        if (code) {
            return $definitions.selects.getValue(MEDICATION_TIMING_ABBREVIATION_SELECT_ID, code);
        }
        return { title: (_f = (_e = (_d = this.data.dosage) === null || _d === void 0 ? void 0 : _d.timing) === null || _e === void 0 ? void 0 : _e.code) === null || _f === void 0 ? void 0 : _f.text };
    }
    get derivationReason() {
        return $definitions.selects.getValue(MEDICATION_DERIVATION_REASON_SELECT_ID, this.data.derivationReason);
    }
    get note() {
        return this.data.note;
    }
}
export class MedicationStatementExtractor extends MedicationsExtractor {
    getStatusSelectId() {
        return MEDICATION_STATEMENT_STATUS_SELECT_ID;
    }
}
export class MedicationRequestExtractor extends MedicationsExtractor {
    getStatusSelectId() {
        return MEDICATION_REQUEST_STATUS_SELECT_ID;
    }
    get intent() {
        return $definitions.selects.getValue(MEDICATION_REQUEST_INTENT_SELECT_ID, this.data.intent);
    }
}
